import { Controller, useFormContext } from "react-hook-form";
import { Checkbox, CheckboxGroup, CheckboxGroupProps, Form } from "rsuite";

interface Option {
  label: string;
  value: string | boolean | number;
}

interface Props extends Omit<CheckboxGroupProps, "value" | "onChange"> {
  name: string;
  label?: string;
  options: Option[];
  singleSelect?: boolean; // if true, only one item can be selected
}

const CheckboxGroupInput = ({
  name,
  label,
  options,
  singleSelect = false,
  ...rest
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const hasErrors = !!errors[name];
  return (
    <Form.Group controlId={name}>
      <div className={hasErrors ? "mb-8" : "mb-3"}>
        {label && <Form.ControlLabel>{label}</Form.ControlLabel>}

        <Controller
          name={name}
          control={control}
          render={({ field }) => {
            const selectedValue = field.value;

            return (
              <CheckboxGroup
                className="p-0 m-0"
                {...rest}
                name={field.name}
                value={
                  singleSelect
                    ? selectedValue
                      ? [selectedValue]
                      : []
                    : Array.isArray(selectedValue)
                    ? selectedValue
                    : []
                }
                onChange={(selected) => {
                  if (singleSelect) {
                    const last = selected[selected.length - 1];
                    field.onChange(last);
                  } else {
                    field.onChange(selected);
                  }
                }}
              >
                <div className="flex gap-2">
                  {options.map((option) => (
                    <Checkbox
                      key={String(option.value)}
                      value={String(option.value)}
                    >
                      {option.label}
                    </Checkbox>
                  ))}
                </div>
              </CheckboxGroup>
            );
          }}
        />

        <Form.ErrorMessage
          show={!!errors[name]}
          placement="bottomStart"
          className="text-wrap w-full"
        >
          <span className="text-wrap">
            {String(errors[name]?.message) || "This field is required"}
          </span>
        </Form.ErrorMessage>
      </div>
    </Form.Group>
  );
};

export default CheckboxGroupInput;
